export default __webpack_public_path__ + "static/media/Footpad's Bracers of the Nadir.c8b756a9.jpg";